import { styled, TableContainer } from '@mui/material';

const TableCardContainer = styled(TableContainer)({
  margin: '0 -16px',
});

export default TableCardContainer;
